<template>
    <div>
        <!-- Tên -->
        <div class="user_info_details">
            <label class="user_info_details_name" style="width:40%">{{$t('new.title171')}}</label>
            <span class="user_info_details_info" style="width:59%">{{loginName}}</span>
        </div>
        <!-- Tổ chức -->
        <div class="user_info_details">
            <label class="user_info_details_name" style="width:40%">{{$t('manage_student.chi_nhanh')}}</label>
            <span class="user_info_details_info" style="width:59%">{{user_info.belongingDeptName}}</span>
        </div>
        <!-- Năm sinh -->
        <div class="user_info_details">
            <label class="user_info_details_name" style="width:40%">{{$t('personSet.birthday')}}</label>
            <span class="user_info_details_info" style="width:59%">{{user_info.birthDay}}</span>
        </div>
        <!-- Giới tính -->
        <div class="user_info_details">
            <label class="user_info_details_name" style="width:40%">{{$t('manage.sex')}}</label>
            <span class="user_info_details_info" style="width:59%">
                <span v-if="user_info.gender=='1'">{{$t('manage_student.male')}}</span>
                <span v-else-if="user_info.gender=='2'">{{$t('manage_student.female')}}</span>
                <span v-else></span>
            </span>
        </div>
        <!-- Thông tin liên lạc -->
        <div class="user_info_details">
            <label class="user_info_details_name" style="width:40%">{{$t('manage_student.mobile')}}</label>
            <span class="user_info_details_info" style="width:59%">{{user_info.mobile}}</span>
        </div>
        <!-- Nghề nghiệp -->
        <div class="user_info_details">
            <label class="user_info_details_name" style="width:40%">{{$t('personSet.occupation')}}</label>
            <span class="user_info_details_info" style="width:59%">{{user_info.job}}</span>
        </div>
        <!-- Ngôn ngữ -->
        <div class="user_info_details">
            <label class="user_info_details_name" style="width:40%">
                {{$t('aicourse.courseLanguage')}}
            </label>
            <span class="user_info_details_info" style="width:59%">
                <span v-for="item in user_info.areaList" :key="item.value" >
                    <span v-if="item.value==user_info.area">
                        {{item.label}}
                    </span>
                </span>
            </span>
        </div>
        <div class="btn-infouser">
            <button @click="chang_edit()">{{$t('new.title25')}}</button>
        </div>
    </div>
</template>
<script>

export default {
    props: {
      data: {
        type:Object,
        default: {},
        loginName : null
      }
    },
    data() {
        return {
            user_info: {},
        };
    },
    created() {
        const loginName = sessionStorage.getItem('loginName');
        this.loginName = loginName;
    },
    beforeDestroy() {},
    mounted() {
        this.user_info = this.data;
    },
    methods: {
        chang_edit(){
            this.$emit("clickNextPageUpdate", false);
        },
    },
};
</script>
<style scoped>
.btn-infouser button{
    float: right;
    margin-top: 15px;
    padding: 10px;
    border-radius: 5px;
    border: 0;
    background: #0071c5;
    color: #fff;
    margin-left: 10px;
}
.btn-infouser button:hover {
    background: #007aff!important;
}
.user_info_details{
    display: flex;
    /* justify-content: space-between; */
    padding: 10px 25px;
}
.user_info_details_name {
    font-size: 14px;
    font-weight: 700;
    width: 350px;
}
.user_info_details_info {
    font-size: 14px;
}
@media (max-width: 480px) {
    .user_info_details{
        padding: 10px 0px!important;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/personSet/infoUser/detailsInfo/details.vue